import { AudioOutlined } from '@ant-design/icons';

const SpeechToTextButton = (props) => {
    
    return (
        <>
        <div className='speech-to-text-button'>
            <div
                className={`microphone ${!props.isCreditsAvailable ? 'disabled' : ''}`}
                onClick={props.isCreditsAvailable ? props.onClick : undefined}
            >
                <>
                    <AudioOutlined />
                    <span>Speech To Text</span>
                </>
            </div>

            {!props.isCreditsAvailable && <div className="no-credits-overlay">No Credits Available.</div>}
            </div>
        </>
    )
}

export default SpeechToTextButton